"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.availabilityApi = void 0;
exports.availabilityApi = (http, prefix = '/availability') => ({
    getEventsByPropertyId(propertyId) {
        return http.get(`${prefix}/events/property/${propertyId}`);
    },
    createEvent(event) {
        return http.post(`${prefix}/events/property/${event.property_id}`, event);
    },
    deleteEvent(event) {
        return http.delete(`${prefix}/property/${event.property_id}/events/${event.id}`);
    }
});
//# sourceMappingURL=index.js.map